export const authInitialState = {
  auth: {
    meta: {
      isLoading: false,
      hasError: false
    },
    accessLevel: null,
    canAccessCurrentHost: false,
    accessHosts: [],
    currentHost: null,
    canShow: {
      home: false,
      reports: false,
      accounts: false,
      daemons: false,
      plugin: false,
      staff: false,
      credetials: false,
      letters: false,
      statistics: false,
      clientsList: false,
      calendar: false,
      calendar2: false,
      transfers: false,
      archives: false,
      contactInfo: false,
      payers: false,
      gifts: false,
      dashboard: false,
      general: false,
      wallet: false,
      chats: false,
      ai_reports: false
    },
    get isLoggedId() {
      return !!this.accessLevel;
    }
  }
};
